import { useState, useEffect, FocusEvent, type MouseEvent, type ChangeEvent } from 'react';
import type { IToggle, IToggleInternalProps } from '../../types/Toggle/toggle';
import styles from './toggle.module.scss';

export const Toggle = ({
    size = "md",
    color = "default",
    disabled = false,
    checked = false,
    onChangeHandler,
    onBeforeToggleConfirmation,
    ...internalProps
}: IToggle) => {

    const { hovered = false, focused = false } = internalProps as IToggleInternalProps;

    const [isToggleHovered, setIsToggleHovered] = useState(hovered);
    const [isToggleFocused, setIsToggleFocused] = useState(focused);
    const [isToggleChecked, setIsToggleChecked] = useState(checked);

    const onMouseOverHandler = () => {
        setIsToggleHovered(true);
    };

    const onMouseOutHandler = () => {
        setIsToggleHovered(false);
    };

    const onFocusHandler = (event: FocusEvent<HTMLLabelElement>) => {
        event.preventDefault();
        setIsToggleFocused(true);
    };

    const onBlurHandler = (event: FocusEvent<HTMLLabelElement>) => {
        event.preventDefault();
        setIsToggleFocused(false);
    };

    useEffect(() => {
        setIsToggleHovered(hovered);
    }, [hovered]);

    useEffect(() => {
        setIsToggleFocused(focused);
    }, [focused]);

    useEffect(() => {
        setIsToggleChecked(checked);
    }, [checked]);

    const onClickHandler = async (e: MouseEvent<HTMLLabelElement>) => {
        e.preventDefault();
        if (onBeforeToggleConfirmation) {
            const shouldToggle = await onBeforeToggleConfirmation(isToggleChecked);
            if (shouldToggle) {
                setIsToggleChecked(!isToggleChecked);
            }
        } else {
            setIsToggleChecked(!isToggleChecked);
        }
    };

    useEffect(() => {
        onChangeHandler?.(isToggleChecked);
    }, [isToggleChecked]);

    return (
        <label
            id="toggle-base"
            className={styles['toggle']}
            data-toggle-size={size}
            data-toggle-color={color}
            data-toggle-is-hovered={isToggleHovered}
            data-toggle-is-focused={isToggleFocused}
            data-toggle-is-checked={isToggleChecked}
            data-toggle-is-disabled={disabled}
            onClick={onClickHandler}
            onMouseOver={onMouseOverHandler}
            onMouseOut={onMouseOutHandler}
            onFocusCapture={onFocusHandler}
            onBlurCapture={onBlurHandler}
        >
            <input type="checkbox" checked={isToggleChecked} onChange={() => { }} disabled={disabled} />
            <div className={styles['toggle__slider']} id="toggle-base-slider"></div>
        </label>
    )
}